import classNames from 'classnames/bind';
import { BCButtonBar } from '..';
import Styles from './assets/style.scss';
import { IAddonButton } from './entities';

const cx = classNames.bind(Styles);

const BCAddonButton = (props: IAddonButton) => {
	const renderRibbon = () => {
		const {
			className,
			style,
			farItems = [],
			items = [],
			overflowButtonProps,
			elementsCountToShow,
			overflowMenuProps
		} = props;

		const sortedSeparationList = ['0'].concat(items.map(t => t.separationId));
		const ribbonClassNames = cx({
			[className]: true,
			ribbonBar: true,
			ribbonMargin: farItems.length || items.length
		});

		return (
			<BCButtonBar
				className={ribbonClassNames}
				style={style}
				elementsCountToShow={elementsCountToShow || 2}
				overflowMenuProps={overflowMenuProps}
				overflowButtonProps={overflowButtonProps}
				items={items}
				farItems={farItems}
				sortedSeparationList={sortedSeparationList}
				isPopoverAutoClose
			/>
		);
	};

	const renderAddon = () => <div className={Styles.addon}>{props.children}</div>;

	return (
		<div className={Styles.AddonButtonContainer}>
			{renderAddon()}
			{renderRibbon()}
		</div>
	);
};

export default BCAddonButton;
export { IAddonButton };
